import React, { memo, useState } from 'react';
import { arrayOf, node, shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import Button from '../../atoms/button/button';
import LocationLegendModal from '../../../location/locationLegendModal/LocationLegendModal';
import './locationlegend.scss';

const LocationLegend = ({ title, legendItems = [], classNamePrefix = 'location' }) => {
    const [isLocationInfoModal, setLocationInfoModal] = useState(false);
    const [legendContent, setLegendContent] = useState(null);
    const intl = useIntl();

    const handleLocationInfoModal = (item) => {
            setLegendContent(item);
            setLocationInfoModal(true);
    };

    const handleLocationInfoModalClose = () => {
        setLocationInfoModal(false);
        setLegendContent(null);
    };

    return (
        <>
            {legendItems?.length > 0 && (
                <div className={`${classNamePrefix}__legend`}>
                    {title && (
                        <h6
                            className={`${classNamePrefix}__legend-title`}
                            tabIndex="0"
                            data-testid={`${classNamePrefix}legend-title`}>
                            {title}
                        </h6>
                    )}
                    {legendItems?.map((item) => (
                        <Button
                            key={item?.name}
                            className={`${classNamePrefix}__legend-item`}
                            tabIndex="0"
                            onClick={() => handleLocationInfoModal(item)}
                            buttonAriaLabel={`${intl.formatMessage({ id: 'common-open-text' })} ${
                                item?.name
                            } ${intl.formatMessage({ id: 'common-info-modal-text' })}`}>
                            {item?.icon} <small>{item?.name}</small>
                        </Button>
                    ))}
                </div>
            )}

            {isLocationInfoModal && legendContent && (
                <LocationLegendModal
                    isOpen={isLocationInfoModal}
                    onRequestClose={handleLocationInfoModalClose}
                    title={
                        <>
                            {legendContent?.icon} {legendContent?.name}
                        </>
                    }
                    content={
                        <>
                            <div
                                dangerouslySetInnerHTML={{ __html: legendContent?.content }}
                                tabIndex="0"
                                className="location-legend-modal__content-in"
                            />
                            {legendContent?.link && (
                                <a href={legendContent?.link} className="location-legend-modal__link" tabIndex="0">
                                    {intl.formatMessage({ id: 'common:learn-more' })}
                                </a>
                            )}
                        </>
                    }
                    handleClose={handleLocationInfoModalClose}
                />
            )}
        </>
    );
};

LocationLegend.defaultProps = {
    title: '',
    legendItems: [],
    classNamePrefix: 'location'
};

LocationLegend.propTypes = {
    title: string,
    legendItems: arrayOf(
        shape({
            name: string,
            icon: node,
            content: string,
            link: string
        })
    ),
    classNamePrefix: string
};

export default memo(LocationLegend);